import React, { createContext, useState, useContext, useEffect } from "react";
import {
  getAuth,
  onAuthStateChanged,
  signInAnonymously,
  signOut as firebaseSignOut,
} from "firebase/auth";
import { app } from "../firebase/config";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth(app);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);

      if (user) {
        console.log("🔐 User authenticated:", {
          uid: user.uid,
          email: user.email,
          isAnonymous: user.isAnonymous,
        });
      } else {
        console.log("🔐 User not authenticated");
      }
    });

    return () => unsubscribe();
  }, [auth]);

  // Đăng nhập ẩn danh để có authentication cho Firestore
  const signInAnonymouslyIfNeeded = async () => {
    if (!user) {
      try {
        console.log("🔐 Signing in anonymously for Firestore access...");
        const result = await signInAnonymously(auth);
        console.log("✅ Anonymous sign in successful:", result.user.uid);
        return result.user;
      } catch (error) {
        console.error("❌ Anonymous sign in failed:", error);
        throw error;
      }
    }
    return user;
  };

  // Đăng xuất
  const signOut = async () => {
    try {
      await firebaseSignOut(auth);
      console.log("✅ Sign out successful");
    } catch (error) {
      console.error("❌ Sign out failed:", error);
      throw error;
    }
  };

  const value = {
    user,
    loading,
    signInAnonymouslyIfNeeded,
    signOut,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
